import Licenses from '../../../../domain/license/Licenses'
import Users from '../../../../domain/user/Users'
import VehicleLicenseTypes from '../../../../domain/vehicle/VehicleLicenseTypes'
import { UserState } from './UserState'

export const initialUserState: UserState = {
  allUsers: Users.empty(),
  createUser: undefined,

  allStudents: Users.empty(),
  filteredStudents: Users.empty(),
  currentStudent: undefined,
  updateStudent: undefined,

  vehicleLicenses: VehicleLicenseTypes.empty(),
  licenses: Licenses.empty(),
  selectedLicense: undefined,

  createDebt: undefined,
  createPayment: undefined,

  editMode: false,
  isValid: false,
}
